<template>
    <b-modal id="crb-info-modal" title="Understanding Credit Reference Bureaus (CRB)" size="lg" hide-footer centered>
        <div class="p-2">
            <h5 class="text-primary mb-3">What is a Credit Reference Bureau?</h5>
            <p>
                A Credit Reference Bureau (CRB) is an independent organization that collects and maintains detailed
                information about consumers' credit histories. They gather data from various financial institutions,
                including commercial banks, microfinance deposit-taking institutions (MDIs), SACCOs, and credit
                institutions.
            </p>

            <h5 class="text-primary mt-4 mb-3">How Does It Work?</h5>
            <ul>
                <li class="mb-2">
                    <strong>Data Collection:</strong> Lenders routinely submit data to the CRB regarding their
                    customers' active loans, repayment behaviors, defaults, and bounced cheques.
                </li>
                <li class="mb-2">
                    <strong>Profile Building:</strong> The CRB aggregates this data to create a comprehensive financial
                    profile for each individual, tracking both positive behavior (paying on time) and negative behavior
                    (late payments or defaults).
                </li>
                <li class="mb-2">
                    <strong>Reporting & Scoring:</strong> When an individual applies for new credit, the lender requests
                    a CRB report. The CRB returns a detailed history and often a <strong>Credit Score</strong>—a
                    numerical representation of the borrower's risk level based on their past financial behavior.
                </li>
            </ul>

            <h5 class="text-primary mt-4 mb-3">Why is this Important?</h5>
            <p>
                Protecting members' savings is the highest priority. Using CRB reports helps in several
                ways:
            </p>
            <ul>
                <li class="mb-2"><strong>Risk Mitigation:</strong> Identifies applicants who are over-indebted or have a
                    history of defaulting at other institutions before you issue a loan.</li>
                <li class="mb-2"><strong>Fair Assessment:</strong> Allows loan officers to make objective, data-driven
                    decisions rather than relying solely on personal guarantees or localized history.</li>
                <li class="mb-2"><strong>Rewarding Good Borrowers:</strong> Members with excellent external credit
                    scores can be confidently offered better loan terms or faster approvals.</li>
            </ul>

            <h5 class="text-primary mt-4 mb-3">Data Protection and Privacy</h5>
            <div class="bg-light p-3 rounded border">
                <p class="mb-2 text-dark">
                    At Tandika Technologies, we are committed to maintaining the highest standards of data security. We
                    ensure that all Credit Reference Bureau (CRB) information processed within our system
                    remains encrypted, secure, and accessible only to authorized personnel.
                </p>
                <p class="mb-2 text-dark">
                    As a system user, you are required to extend this duty of care. Any credit information that is
                    exported, downloaded, or printed outside of the Tandika System must be handled with strict
                    confidentiality and disclosed solely to authorized individuals.
                </p>
                <p class="mb-0 text-danger fw-bold">
                    Disclaimer: Tandika Technologies assumes no liability for any privacy breaches, unauthorized
                    sharing, or data mismanagement resulting from the handling of CRB reports outside of our secure
                    infrastructure.
                </p>
            </div>

            <div class="text-end mt-4">
                <b-button variant="secondary" @click="$bvModal.hide('crb-info-modal')">Close</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "CrbInfoModal"
};
</script>